/**
 * @generated SignedSource<<c5b8bfafb46ab39062bf5dac3335ef4b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecordVideoButton_Question$data = {
  readonly id: string;
  readonly rawId: number | null | undefined;
  readonly title: string;
  readonly videoAnswer: {
    readonly video: {
      readonly " $fragmentSpreads": FragmentRefs<"RecordVideoButton_Video">;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "RecordVideoButton_Question";
};
export type RecordVideoButton_Question$key = {
  readonly " $data"?: RecordVideoButton_Question$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecordVideoButton_Question">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecordVideoButton_Question",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rawId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Answer",
      "kind": "LinkedField",
      "name": "videoAnswer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Video",
          "kind": "LinkedField",
          "name": "video",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "RecordVideoButton_Video"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Question",
  "abstractKey": null
};

(node as any).hash = "c2c79c6951fbe1d4d25638e891ccc3df";

export default node;
